<div class="panel panel-font gradient-bg">
  <a [routerLink]="'/'" class="closeBtn" title="{{ 'zavřít' | translate }}"></a>

  <div *ngIf="loading">
    <app-loading></app-loading>
  </div>

  <div *ngIf="connection && !loading">
    <div class="d-flex">
      <div class="icon{{connection.iconClass()}}new connection-image float-start me-4">
        <span></span>
      </div>
      <div class="">
        <span class="panel-title">
          {{prefname}}
          <app-connection-icons [connection]="connection"></app-connection-icons>
        </span>
        <div class="connection-company-name">{{connection.operator}}</div>
        @if (timeAtStopFrom) {
        <div class="connection-company-name">{{'příjezd' | translate}}: {{timeAtStopFrom}}</div>
        }
      </div>
    </div>

    <div class="panel-section">
      <div class="connection-info">
        <span>
          <span class="text-gray">
            {{connection.distance}} km
          </span>
          <span class="fw-bolder ms-2">
            @if (connection.durationHours > 0) {
            {{connection.durationHours}}&nbsp;hod {{connection.durationMinutes}}&nbsp;min
            }
            @else {
            {{connection.durationMinutes}}&nbsp;min
            }
          </span>
        </span>
        @if (delay && delay > 0) {
        <span class="panel-delay" [class.small]="delay < 5" [class.medium]="delay >= 5 && delay < 20">
          +&nbsp;{{delay}}&nbsp;min
        </span>
        }
      </div>
      <div class="station-info mt1">
        <span>{{connection.dep()}}</span>
        <span class="platform">{{connection.depPlatform()}}</span>
        <span class="times fw-bolder">{{connection.depTime()}}</span>
      </div>
      <div class="station-info mt1">
        <span>{{connection.dest()}}</span>
        <span class="platform">{{connection.destPlatform()}}</span>
        <span class="times fw-bolder">{{connection.destTime()}}</span>
      </div>
    </div>

    <div class="stations-section">
      <ul class="mainList">
        @for(item of connection.stations; track $index;)
        {
        <li class="clickable clickable-list station-row" tabindex="0">
          <div class="row station-items" [ngClass]="{'fw-light': item.passed}" (click)="onStationClick(item.id)">
            <div class="column-times fw-bolder" [ngClass]="{'arrAndDep': item.departureTime && item.arrivalTime && item.arrivalTime != item.departureTime}">
              <div class="arrival">
                {{hasArrivals && item.arrivalTime != null ? item.arrivalTime : item.departureTime}}
              </div>
              @if (item.departureTime) {
              <div class="departure">
                {{this.hasArrivals && item.arrivalTime != null && item.arrivalTime != item.departureTime ? item.departureTime : ''}}
              </div>
              }
            </div>
            <div class="column-line">
              @if (item.id == stopFromId) {
              <div class="selectedStation {{stationHasArrAndDep(item) ? 'arrAndDep' : ''}} border{{connection.iconClass()}}"></div>
              }
              <div class="line-point {{stationHasArrAndDep(item) ? 'arrAndDep' : ''}} {{item.passed ? '' : 'line-filled'}}{{connection.iconClass()}}"></div>
              <div class="line-top {{stationHasArrAndDep(item) ? 'arrAndDep' : ''}} {{$index != 0 && connection.stations[$index-1].passed ? '' : 'line-filled'}}{{connection.iconClass()}}" [style.visibility]="$first ? 'hidden' : 'visible'"></div>
              @if ($index >= 0) {
              <div class="line-bottom {{stationHasArrAndDep(item) ? 'arrAndDep' : ''}} {{item.passed ? '' : 'line-filled'}}{{connection.iconClass()}}" [style.visibility]="$last ? 'hidden' : 'visible'"></div>
              }
            </div>
            <div class="column-stations">
              <div>
                {{item.name | breakAfterComma}}
                @if (item.isRequestStation()) {
                <span class="ttFont ms-2" title="{{'na znamení' | translate}}">D</span>
                }
                @if (item.isWheelchairAccessible()) {
                <span class="ttFont ms-2" title="{{'bez bariér' | translate}}">H</span>
                }
                @if (item.hasCatering()) {
                <span class="ttFont ms-2" title="{{'občerstvení' | translate}}">M</span>
                }
                @if (item.isBlindAccessible()) {
                <span class="ttFont ms-2" title="{{'nevidomí' | translate}}">G</span>
                }
              </div>
              @if (item.delay && item.delay > 0) {
              <div><span class="wrap panel-delay" [class.passed]="item.passed" [class.small]="item.delay < 5" [class.medium]="item.delay >= 5 && item.delay < 20">+{{item.delay}} min</span></div>
              }
              @else {
              @if ($index >= 0 && item.delay == -1) {
              <div><span class="wrap panel-no-delay" [class.passed]="item.passed">{{'včas' | translate}}</span></div>
              }
              }
            </div>
            <div class="column-platform platform">{{item.platform}}</div>
            <div class="column-zone" title="{{'zóna' | translate}}">{{item.zone}}</div>
          </div>
        </li>
        }
      </ul>
    </div>
  </div>
</div>
